
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{fontFamily: '"Pacifico", serif'}}>
              TechServe
            </h3>
            <p className="text-gray-300 mb-4 max-w-md">
              Leading IT consulting company providing comprehensive technology solutions to help businesses thrive in the digital age.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">IT Consulting</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Cloud Migration</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Cybersecurity</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Software Development</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Data Analytics</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-2">
              <li className="text-gray-300 flex items-center">
                <i className="ri-phone-fill mr-2"></i>
                +1 (555) 123-4567
              </li>
              <li className="text-gray-300 flex items-center">
                <i className="ri-mail-fill mr-2"></i>
                info@techserve.com
              </li>
              <li className="text-gray-300 flex items-start">
                <i className="ri-map-pin-fill mr-2 mt-1"></i>
                123 Technology Drive<br/>Silicon Valley, CA 94025
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-300 text-sm">
            © 2024 TechServe. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
